import React, { useCallback, useEffect, useMemo, useState } from "react"
import { apiV2 } from "../../../repositories/repository"
import useSWR from "swr"
import { useHistory, useParams } from "react-router-dom"
import { Chart } from "chart.js/auto"
import { translate } from "../../../selectors/translations"
import { ReactComponent as BackIcon } from '../../../assets/img/icons/arrow_left_icon.svg'
import { RouteNames } from "../../../types/constants"
import { DatePicker } from "rsuite"
import 'rsuite/DatePicker/styles/index.css'
import 'rsuite/Tabs/styles/index.css'
import 'rsuite/SelectPicker/styles/index.css'
import dayjs from "dayjs"
import annotationPlugin from 'chartjs-plugin-annotation'
import useTranslate from "../../../hooks/useTranslate"
import { type ProgramDataDto, ProgramTaskActionType, ProgramTaskDto } from "../../../sdk"
import './PatientProgram.scss'
import { lineChartConfig } from "../PatientGameStats/PatientGameStatsCommon"

Chart.register(annotationPlugin)

const centerTextPlugin = {
  id: 'centerText',
  afterDraw(chart, args, options) {
    const {ctx, chartArea: {width, height}} = chart
    const value = options.text
    if (value) {
      ctx.save()
      ctx.font = 'bold 16px system-ui'
      ctx.fillStyle = '#444'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(value, width / 2, height / 2)
      ctx.restore()
    }
  }
}

Chart.register(centerTextPlugin)

const makeIcon = (svgMarkup: string) => {
  const blob = new Blob([svgMarkup], {type: 'image/svg+xml'})
  const url = URL.createObjectURL(blob)

  const svgIcon = new Image()
  svgIcon.src = url

  return svgIcon
}

const images = {
  0: makeIcon(`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#FE6D3F"/><path d="M27.1708 17.4898C27.9368 17.4898 28.5864 17.2217 29.1194 16.6855C29.6525 16.1493 29.919 15.4981 29.919 14.732C29.919 13.966 29.6509 13.3165 29.1147 12.7834C28.5784 12.2503 27.9273 11.9838 27.1612 11.9838C26.3952 11.9838 25.7456 12.2519 25.2126 12.7882C24.6795 13.3244 24.413 13.9755 24.413 14.7416C24.413 15.5077 24.6811 16.1572 25.2173 16.6903C25.7536 17.2233 26.4047 17.4898 27.1708 17.4898ZM12.8388 17.4898C13.6048 17.4898 14.2544 17.2217 14.7874 16.6855C15.3205 16.1493 15.587 15.4981 15.587 14.732C15.587 13.966 15.3189 13.3165 14.7827 12.7834C14.2464 12.2503 13.5953 11.9838 12.8292 11.9838C12.0632 11.9838 11.4136 12.2519 10.8806 12.7882C10.3475 13.3244 10.081 13.9755 10.081 14.7416C10.081 15.5077 10.3491 16.1572 10.8853 16.6903C11.4216 17.2233 12.0727 17.4898 12.8388 17.4898ZM20 23.1579C17.803 23.1579 15.7949 23.7726 13.9757 25.002C12.1566 26.2314 10.8151 27.8569 9.95145 29.8785H12C12.7719 28.5803 13.7193 26.7544 15 26C16.2807 25.2456 18.4947 24.5 20.0035 24.5C21.5123 24.5 23.7193 25.2456 25 26C26.2807 26.7544 27.2281 28.5803 28 29.8785H30.0486C29.1849 27.8569 27.8434 26.2314 26.0243 25.002C24.2051 23.7726 22.197 23.1579 20 23.1579ZM20.0035 40C17.2373 40 14.6373 39.4751 12.2033 38.4253C9.76929 37.3754 7.65206 35.9507 5.85159 34.151C4.0511 32.3513 2.62571 30.235 1.57543 27.8021C0.525142 25.3692 0 22.7697 0 20.0035C0 17.2373 0.524914 14.6373 1.57474 12.2033C2.62457 9.76929 4.04931 7.65206 5.84896 5.8516C7.64865 4.0511 9.76496 2.62571 12.1979 1.57543C14.6308 0.525144 17.2303 0 19.9965 0C22.7627 0 25.3627 0.524916 27.7967 1.57474C30.2307 2.62457 32.3479 4.04931 34.1484 5.84896C35.9489 7.64865 37.3743 9.76496 38.4246 12.1979C39.4749 14.6308 40 17.2303 40 19.9965C40 22.7627 39.4751 25.3627 38.4253 27.7967C37.3754 30.2307 35.9507 32.3479 34.151 34.1484C32.3513 35.9489 30.235 37.3743 27.8021 38.4246C25.3692 39.4749 22.7697 40 20.0035 40ZM19.9965 38.4246C24.6982 38.4246 29.7368 36.2632 33 33C36.2632 29.7368 38 24.7053 38 20.0035C38 15.3018 36.2632 10.2632 33 7C29.7368 3.73683 24.7053 1.57543 20.0035 1.57543C15.3018 1.57543 10.7632 3.73683 7.5 7C4.23683 10.2632 2 15.3018 2 20.0035C2 24.7053 4.23683 29.7368 7.5 33C10.7632 36.2632 15.2947 38.4246 19.9965 38.4246Z" fill="black"/></svg>`),
  1: makeIcon(`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#83B8FC"/><path d="M27.1708 17.4898C27.9368 17.4898 28.5864 17.2217 29.1194 16.6855C29.6525 16.1493 29.919 15.4981 29.919 14.732C29.919 13.966 29.6509 13.3165 29.1147 12.7834C28.5784 12.2503 27.9273 11.9838 27.1612 11.9838C26.3952 11.9838 25.7456 12.2519 25.2126 12.7882C24.6795 13.3244 24.413 13.9755 24.413 14.7416C24.413 15.5077 24.6811 16.1572 25.2173 16.6903C25.7536 17.2233 26.4047 17.4898 27.1708 17.4898ZM12.8388 17.4898C13.6048 17.4898 14.2544 17.2217 14.7874 16.6855C15.3205 16.1493 15.587 15.4981 15.587 14.732C15.587 13.966 15.3189 13.3165 14.7827 12.7834C14.2464 12.2503 13.5953 11.9838 12.8292 11.9838C12.0632 11.9838 11.4136 12.2519 10.8806 12.7882C10.3475 13.3244 10.081 13.9755 10.081 14.7416C10.081 15.5077 10.3491 16.1572 10.8853 16.6903C11.4216 17.2233 12.0727 17.4898 12.8388 17.4898ZM13.8461 27.0445H26.1539V25.5H13.8461V27.0445ZM20.0035 40C17.2373 40 14.6373 39.4751 12.2033 38.4253C9.76929 37.3754 7.65206 35.9507 5.85159 34.151C4.0511 32.3513 2.62571 30.235 1.57543 27.8021C0.525142 25.3692 0 22.7697 0 20.0035C0 17.2373 0.524914 14.6373 1.57474 12.2033C2.62457 9.76929 4.04931 7.65206 5.84896 5.8516C7.64865 4.0511 9.76496 2.62571 12.1979 1.57543C14.6308 0.525144 17.2303 0 19.9965 0C22.7627 0 25.3627 0.524916 27.7967 1.57474C30.2307 2.62457 32.3479 4.04931 34.1484 5.84896C35.9489 7.64865 37.3743 9.76496 38.4246 12.1979C39.4749 14.6308 40 17.2303 40 19.9965C40 22.7627 39.4751 25.3627 38.4253 27.7967C37.3754 30.2307 35.9507 32.3479 34.151 34.1484C32.3513 35.9489 30.235 37.3743 27.8021 38.4246C25.3692 39.4749 22.7697 40 20.0035 40ZM20.0035 38.4246C24.7053 38.4246 29.7368 36.2632 33 33C36.2632 29.7368 38.4246 24.7053 38.4246 20.0035C38.4246 15.3018 36.2632 10.2632 33 7C29.7368 3.73683 24.7053 1.57543 20.0035 1.57543C15.3018 1.57543 10.2632 3.73683 7 7C3.73683 10.2632 1.57543 15.3018 1.57543 20.0035C1.57543 24.7053 3.73683 29.7368 7 33C10.2632 36.2632 15.3018 38.4246 20.0035 38.4246Z" fill="black"/></svg>`),
  2: makeIcon(`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#FFD800"/><path d="M27.1708 17.4898C27.9368 17.4898 28.5864 17.2217 29.1194 16.6855C29.6525 16.1493 29.919 15.4981 29.919 14.732C29.919 13.966 29.6509 13.3165 29.1147 12.7834C28.5784 12.2503 27.9273 11.9838 27.1612 11.9838C26.3952 11.9838 25.7456 12.2519 25.2126 12.7882C24.6795 13.3244 24.413 13.9755 24.413 14.7416C24.413 15.5077 24.6811 16.1572 25.2173 16.6903C25.7536 17.2233 26.4047 17.4898 27.1708 17.4898ZM12.8388 17.4898C13.6048 17.4898 14.2544 17.2217 14.7874 16.6855C15.3205 16.1493 15.587 15.4981 15.587 14.732C15.587 13.966 15.3189 13.3165 14.7827 12.7834C14.2464 12.2503 13.5953 11.9838 12.8292 11.9838C12.0632 11.9838 11.4136 12.2519 10.8806 12.7882C10.3475 13.3244 10.081 13.9755 10.081 14.7416C10.081 15.5077 10.3491 16.1572 10.8853 16.6903C11.4216 17.2233 12.0727 17.4898 12.8388 17.4898ZM20 30.9311C22.197 30.9311 24.2051 30.3164 26.0243 29.087C27.8434 27.8576 29.1849 26.2321 30.0486 24.2105H27.8021C27.0302 25.5088 26.2807 26.7456 25 27.5C23.7193 28.2544 21.5123 29.087 20.0035 29.087C18.4947 29.087 16.2807 28.2544 15 27.5C13.7193 26.7456 12.9752 25.5088 12.2033 24.2105H9.95145C10.8151 26.2321 12.1566 27.8576 13.9757 29.087C15.7949 30.3164 17.803 30.9311 20 30.9311ZM20.0035 40C17.2373 40 14.6373 39.4751 12.2033 38.4253C9.76929 37.3754 7.65206 35.9507 5.85159 34.151C4.0511 32.3513 2.62571 30.235 1.57543 27.8021C0.525142 25.3692 0 22.7697 0 20.0035C0 17.2373 0.524914 14.6373 1.57474 12.2033C2.62457 9.76929 4.04931 7.65206 5.84896 5.8516C7.64865 4.0511 9.76496 2.62571 12.1979 1.57543C14.6308 0.525144 17.2303 0 19.9965 0C22.7627 0 25.3627 0.524916 27.7967 1.57474C30.2307 2.62457 32.3479 4.04931 34.1484 5.84896C35.9489 7.64865 37.3743 9.76496 38.4246 12.1979C39.4749 14.6308 40 17.2303 40 19.9965C40 22.7627 39.4751 25.3627 38.4253 27.7967C37.3754 30.2307 35.9507 32.3479 34.151 34.1484C32.3513 35.9489 30.235 37.3743 27.8021 38.4246C25.3692 39.4749 22.7697 40 20.0035 40ZM20.0035 38.4246C24.7053 38.4246 29.7368 36.2632 33 33C36.2632 29.7368 38.4246 24.7053 38.4246 20.0035C38.4246 15.3018 36.2632 10.2632 33 7C29.7368 3.73683 24.6982 1.57543 19.9965 1.57543C15.2947 1.57543 10.2632 3.73683 7 7C3.73683 10.2632 1.57543 15.3018 1.57543 20.0035C1.57543 24.7053 3.23683 29.2368 6.5 32.5C9.76317 35.7632 15.3018 38.4246 20.0035 38.4246Z" fill="black"/></svg>`),
  3: makeIcon(`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#6DE99E"/><path d="M20 30.9311C22.197 30.9311 24.2051 30.3164 26.0243 29.087C27.8434 27.8576 29.1849 26.2321 30.0486 24.2105H9.95145C10.8151 26.2321 12.1566 27.8576 13.9757 29.087C15.7949 30.3164 17.803 30.9311 20 30.9311ZM11 16.5L13.4737 14L16 16.5L17.4898 15.6842L13.4737 11.6032L9.39271 15.6842L11 16.5ZM24.5 16.5L26.5263 14L29 16.5L30.6073 15.6842L26.5263 11.6032L22.5102 15.6842L24.5 16.5ZM20.0035 40C17.2373 40 14.6373 39.4751 12.2033 38.4253C9.76929 37.3754 7.65206 35.9507 5.85159 34.151C4.0511 32.3513 2.62571 30.235 1.57543 27.8021C0.525142 25.3692 0 22.7697 0 20.0035C0 17.2373 0.524914 14.6373 1.57474 12.2033C2.62457 9.76929 4.04931 7.65206 5.84896 5.8516C7.64865 4.0511 9.76496 2.62571 12.1979 1.57543C14.6308 0.525144 17.2303 0 19.9965 0C22.7627 0 25.3627 0.524916 27.7967 1.57474C30.2307 2.62457 32.3479 4.04931 34.1484 5.84896C35.9489 7.64865 37.3743 9.76496 38.4246 12.1979C39.4749 14.6308 40 17.2303 40 19.9965C40 22.7627 39.4751 25.3627 38.4253 27.7967C37.3754 30.2307 35.9507 32.3479 34.151 34.1484C32.3513 35.9489 30.235 37.3743 27.8021 38.4246C25.3692 39.4749 22.7697 40 20.0035 40ZM20 38.4253C24.7018 38.4253 30.2368 35.7632 33.5 32.5C36.7632 29.2368 38.4246 24.7053 38.4246 20.0035C38.4246 15.3018 36.2632 10.2632 33 7C29.7368 3.73683 24.6982 1.57543 19.9965 1.57543C15.2947 1.57543 10.2632 3.73683 7 7C3.73683 10.2632 1.57543 15.3018 1.57543 20.0035C1.57543 24.7053 3.73683 29.7368 7 33C10.2632 36.2632 15.2982 38.4253 20 38.4253Z" fill="black"/></svg>`),
}

const yLabelsPlugin = {
  id: 'yLabelsWithImages',
  afterDraw(chart, args, options) {
    const {ctx, scales: {y}} = chart
    if (!options.enable) {
      return
    }

    y.ticks.forEach((tick, index) => {
      const label = tick.value
      const img = images[label]
      if (!img) return

      const yPos = y.getPixelForTick(index)
      ctx.drawImage(img, y.left + 30, yPos - 30, 30, 30)
    })
  }
}

Chart.register(yLabelsPlugin)

export function PatientProgram() {
  // @ts-ignore
  const {id: patientId = ''} = useParams()
  const history = useHistory()
  const [dateFrom, setDateFrom] = useState<Date | null>(null)
  const [results, setResults] = useState<ProgramDataDto | null>(null)
  const [dateTo, setDateTo] = useState<Date | null>(null)
  const translateLocalazy = useTranslate()

  const setFilterToCurrentMonth = () => {
    const start = dayjs().startOf('month')
    const end = dayjs().endOf('month')
    setDateFrom(start.toDate())
    setDateTo(end.toDate())
  }
  const setFilterToPreviousMonth = () => {
    const start = dayjs().subtract(1, 'month').startOf('month')
    const end = dayjs().subtract(1, 'month').endOf('month')
    setDateFrom(start.toDate())
    setDateTo(end.toDate())
  }

  const {
    data: rawResults,
    isLoading: isLoadingResults,
  } = useSWR(
    ['api.program.allProgramData', patientId],
    () => apiV2.program.allProgramData(patientId),
    {
      revalidateOnFocus: false,
      revalidateOnMount: true,
      dedupingInterval: 0,
    }
  )

  useEffect(() => {
    if (rawResults) {
      setResults(rawResults)
    }
  }, [rawResults])

  useEffect(() => {
    if (!rawResults) {
      return
    }

    const charts: Chart[] = []
    if (!rawResults) {
      return
    }

    const renderSummaryGraph = (id: string, score: number | undefined) => {
      const ctx = document.getElementById(id)
      if (!ctx) {
        return
      }

      const value = score ? score * 100 : 0
      let color
      if (value < 25) {
        color = '#FF845D'
      } else if (value < 50) {
        color = '#FFE038'
      } else if (value < 75) {
        color = '#83B8FC'
      } else {
        color = '#80DA80'
      }

      // @ts-ignore
      charts.push(new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: [value, 100 - value],
              backgroundColor: [color, '#e5e5e5'],
              borderWidth: 0,
              cutout: '50%',
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {display: false},
            tooltip: {enabled: false},
            centerText: {text: `${value.toFixed(0)}%`},
          },
        },
      }))
    }

    renderSummaryGraph('program-summary-stress', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.STRESS)?.score)
    renderSummaryGraph('program-summary-sleep', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.SLEEP)?.score)
    renderSummaryGraph('program-summary-games', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.GAMES)?.score)
    renderSummaryGraph('program-summary-diet', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.DIET)?.score)
    renderSummaryGraph('program-summary-steps', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.STEPS)?.score)
    renderSummaryGraph('program-summary-social', rawResults.program.progressSummary.tasksScore.find(e => e.action === ProgramTaskActionType.SOCIAL_INTERACTION)?.score)

    return () => {
      charts.map(c => c.destroy())
    }
  }, [rawResults])


  useEffect(() => {
    if (!rawResults) {
      return
    }
    let newResults = {...rawResults}
    if (dateFrom) {
      newResults = {
        program: newResults.program,
        tasks: newResults.tasks.filter(e => {
          const d = dayjs(e.date).tz('utc', true)
          return d.isSame(dateFrom) || d.isAfter(dateFrom)
        })
      }
    }
    if (dateTo) {
      newResults = {
        program: newResults.program,
        tasks: newResults.tasks.filter(e => {
          const d = dayjs(e.date)
          const d2 = dayjs(dateTo).tz('utc', true)
          return d.isSame(d2) || d.isBefore(d2)
        })
      }
    }
    setResults(newResults)

  }, [dateFrom, dateTo])

  const datesWithData = useMemo(() => rawResults?.tasks?.filter(e => e.checkedIn).map(e => e.date) ?? [], [rawResults])

  const handleCancel = useCallback(() => {
    history.push(`${RouteNames.PatientCard}/${patientId}`)
  }, [])

  useEffect(() => {
    const charts: Chart[] = []
    if (!results) {
      return
    }

    const renderDetailedGraph = (id: string, maxY: number, tasks: {
      date: string,
      task: ProgramTaskDto
    }[], type: ProgramTaskActionType) => {
      const chartCtx = document.getElementById(id)
      if (chartCtx) {
        const achieved = tasks.map(e => e.task?.progress ?? 0)
        const targets = tasks.map(e => e.task?.target ?? 0)

        const datasets = [
          {
            label: translateLocalazy('program.chart.progress'),
            data: achieved,
            borderColor: '#8fbc6b',
            backgroundColor: 'rgba(82, 158, 0, 0.15)',
            fill: true,
            pointStyle: 'circle',
            pointRadius: 4,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'monotone',
          }
        ]
        if (targets.some(e => e > 0)) {
          datasets.push({
            label: translateLocalazy('program.chart.target'),
            data: tasks.map(e => e.task?.target ?? 0),
            borderColor: '#6b82bc',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            fill: true,
            pointStyle: 'circle',
            pointRadius: 0,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'monotone',
          })
        }

        const config = {
          ...lineChartConfig(maxY),
          data: {
            labels: tasks.map(e => dayjs(e.date).format('MM/DD')),
            datasets
          }
        }
        if (type === ProgramTaskActionType.STRESS || type === ProgramTaskActionType.DIET) {
          // @ts-ignore
          config.options.scales.y.ticks = {
            callback: () => '',
            padding: 30
          }
          // @ts-ignore
          config.options.plugins = {
            yLabelsWithImages: {enable: true},
          }
        }
        // @ts-ignore
        charts.push(new Chart(chartCtx, config))
      }
    }
    Object.values(ProgramTaskActionType).forEach((type) => {
      const tasks = results.tasks.map(e => {
        const task = {...e.tasks.find(t => t.action === type)!}
        if (type === ProgramTaskActionType.SLEEP) {
          task.progress = task.progress! / 60
          task.target = task.target! / 60
        }
        return ({
          date: e.date,
          task
        })
      },)
      let configStep = results.program.taskConfig.find(t => t.action === type)?.increaseAmountPerLvl ?? 1
      if (type === ProgramTaskActionType.SLEEP) {
        configStep = 1
      }
      const maxValue = tasks.reduce((acc, cur) => Math.max(acc, cur.task?.progress ?? 0, cur.task?.target ?? 0), 0)

      renderDetailedGraph(`program-detailed-${type}`, maxValue + configStep, tasks, type)
    })

    return () => {
      charts.map(c => c.destroy())
    }
  }, [results])

  if (isLoadingResults) {
    return <div className="loader-holder">
      <div className="loader"></div>
    </div>
  }

  return <div className="patient-game-stats">
    <div className="header flex justify-between">
      <div className="back-button flex align-center">
        <BackIcon onClick={handleCancel}/>
        <p onClick={handleCancel}>{translate('back')}</p>
      </div>
      <div className="flex gap">
        <div className="flex flex-column gap">
          <div className="flex justify-end align-center gap">
            <span>{translateLocalazy('patient.game-stats.filter-from')}</span>
            <DatePicker oneTap size="sm"
                        value={dateFrom}
                        onChange={setDateFrom}
                        renderCell={date => {
                          const key = dayjs(date).tz('utc', true).toISOString()
                          const hasCheckIn = datesWithData.includes(key)
                          const day = date.getDate()

                          if (hasCheckIn) {
                            return <span className="day-with-games">{day}</span>
                          }

                          return day
                        }}/>
          </div>
          <div className="flex justify-end align-center gap">
            <span>{translateLocalazy('patient.game-stats.filter-to')}</span>
            <DatePicker oneTap size="sm"
                        value={dateTo}
                        onChange={setDateTo}
                        renderCell={date => {
                          const key = dayjs(date).tz('utc', true).toISOString()
                          const hasCheckIn = datesWithData.includes(key)
                          const day = date.getDate()

                          if (hasCheckIn) {
                            return <span className="day-with-games">{day}</span>
                          }

                          return day
                        }}/>
          </div>
        </div>

        <div className="flex flex-column gap">
          <button className="g_btn g_btn--primary g_btn--small" type="button" onClick={setFilterToCurrentMonth}>
            {translateLocalazy('patient.game-stats.filter-this-month')}
          </button>
          <button className="g_btn g_btn--primary g_btn--small" type="button"
                  onClick={setFilterToPreviousMonth}>
            {translateLocalazy('patient.game-stats.filter-prev-month')}
          </button>
        </div>
      </div>
    </div>

    <div className="card-box">
      <div className="summary-text-info">
        <div>{translateLocalazy('program.start-date')}: <strong>{dayjs(results?.program.createdAt).format('DD-MM-YYYY')}</strong>
        </div>
        <div>{translateLocalazy('program.days-in-program')}: <strong>{results?.program.progressSummary.daysTracked}</strong>
        </div>
        <div>{translateLocalazy('program.consistency')}: <strong>{results?.program.progressSummary.consistencyLvl}</strong>
        </div>
        <div>{translateLocalazy('program.avg-score')}: <strong>{(results?.program.progressSummary.averageScore ?? 0) * 100}%</strong>
        </div>
      </div>
      <div className="center-text">
        {translateLocalazy('program.completed-percent')}
      </div>
      <div className="summary-card">
        <div className="summary-chart">
          <div className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.steps')}</div>
          <canvas id="program-summary-steps"></canvas>
        </div>
        <div className="summary-chart">
          <div className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.sleep')}</div>
          <canvas id="program-summary-sleep"></canvas>
        </div>
        <div className="summary-chart">
          <div className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.games')}</div>
          <canvas id="program-summary-games"></canvas>
        </div>
        <div className="summary-chart">
          <div
            className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.social-interaction')}</div>
          <canvas id="program-summary-social"></canvas>
        </div>
        <div className="summary-chart">
          <div className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.diet')}</div>
          <canvas id="program-summary-diet"></canvas>
        </div>
        <div className="summary-chart">
          <div className="summary-title">{translateLocalazy('patient.administrate.configure-tasks.stress')}</div>
          <canvas id="program-summary-stress"></canvas>
        </div>
      </div>
    </div>
    <div className="card-box detailed-chart">
      <div className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.steps')}</div>
      <canvas id="program-detailed-steps"></canvas>
    </div>
    <div className="card-box detailed-chart">
      <div className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.sleep')}</div>
      <canvas id="program-detailed-sleep"></canvas>
    </div>
    <div className="card-box detailed-chart">
      <div className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.games')}</div>
      <canvas id="program-detailed-games"></canvas>
    </div>
    <div className="card-box detailed-chart">
      <div
        className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.social-interaction')}</div>
      <canvas id="program-detailed-socialInteraction"></canvas>
    </div>
    <div className="card-box detailed-chart">
      <div className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.diet')}</div>
      <canvas id="program-detailed-diet"></canvas>
    </div>
    <div className="card-box detailed-chart">
      <div className="detailed-title">{translateLocalazy('patient.administrate.configure-tasks.stress')}</div>
      <canvas id="program-detailed-stress"></canvas>
    </div>
  </div>
}
